// extracted by mini-css-extract-plugin
export default {"bot":"bot_bot__saAS1","head":"bot_head__W5aRz","table":"bot_table__GQlGq"};